import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function Add(props) {
    return (React.createElement(Svg, { width: props.size, height: props.size, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement(Path, { d: 'M10 15.833a.607.607 0 01-.625-.625v-4.583H4.792A.607.607 0 014.167 10a.607.607 0 01.625-.625h4.583V4.792A.607.607 0 0110 4.167a.607.607 0 01.625.625v4.583h4.583a.607.607 0 01.625.625.607.607 0 01-.625.625h-4.583v4.583a.607.607 0 01-.625.625z', fill: props.color || '#1434CB' })));
}
export default Add;
